import { render, staticRenderFns } from "./Datepicker.vue?vue&type=template&id=670dbb9a&scoped=true"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"
import style0 from "./Datepicker.vue?vue&type=style&index=0&id=670dbb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670dbb9a",
  null
  
)

export default component.exports